import lodash from 'lodash';
import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, VIEW_PAYMENT_APPROVAL_URL } from '../../constants';
import { SET_MODAL_WINDOW_DATA } from '../../../../App/redux/constants/modalWindow.constants';
import { getLeadFinance as getLeadFinanceReq } from '../../requests/leadFinance.requests';
import { readLeadProfileLeadFinanceSuccess } from '../../../Lead_profile/redux/actions/lead_profile_lead_finance.actions';

function* getLeadFinance(payload) {
    const {
        leadId,
        sourceScreen,
        valuationsFromProfile,
        blemQ2,
        leadCustomer,
    } = payload;
    const store = yield select();
    const { dataModel } = store.Leads.LeadPaymentApproval.approvalDetails;

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
        payload: {
            isLoading: true,
            error: null,
            data: null,
        },
    });

    const getLeadFinRes = yield call(getLeadFinanceReq, { leadId });
    const fin = getLeadFinRes.options;
    const updateModelObject = {
        ref_lead: leadId,
    };
    let lastValuation;

    if (!fin) {
        lastValuation = lodash.get(valuationsFromProfile, '0.valuation');

        if (blemQ2 && lodash.isBoolean(blemQ2.value)) {
            if (blemQ2.value) {
                updateModelObject['bought_info.customer_name_v5.value'] = leadCustomer.full_name;
                updateModelObject['bought_info.customer_name_v5.is_locked'] = true;
            } else {
                updateModelObject['bought_info.customer_name_v5.value'] = blemQ2.note;
            }
        }
    } else {
        yield put(readLeadProfileLeadFinanceSuccess(fin));

        const valuations = lodash.get(fin, 'ref_lead.valuations');

        dataModel.set(fin);
        lastValuation = lodash.isArray(valuations)
            && !lodash.isEmpty(valuations)
            && valuations[valuations.length - 1].valuation;
        lodash.merge(updateModelObject, {
            'bought_info.purchasing_team_approval': fin.bought_info.purchasing_team_approval,
            'bought_info.transport_team_approval': fin.bought_info.transport_team_approval,
            'bought_info.accounts_team_approval': fin.bought_info.accounts_team_approval,
        });
    }

    if (lastValuation && !fin) {
        updateModelObject['bought_info.cash_amount'] = lastValuation;
        updateModelObject['bought_info.final_agent_valuation'] = lastValuation;
    }

    // Schema has specific setters which can reset some values, we must to set it additionaly
    dataModel.set(updateModelObject);

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
        payload: {
            $isNew: Boolean(!fin),
            isLoading: false,
            error: getLeadFinRes.error,
            data: fin,
            dataModel,
        },
    });

    if (sourceScreen === VIEW_PAYMENT_APPROVAL_URL) {
        yield put({
            type: SET_MODAL_WINDOW_DATA,
            payload: { isLoading: false },
        });
    }
}

export default function* getLeadFinanceSaga() {
    yield takeEvery(GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, getLeadFinance);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/redux/sagas/getLeadFinance.saga.js